import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
  ChangeDetectionStrategy
} from '@angular/core';
import { ImportComponent } from '../import.component';

@Component({
    selector: 'asap-import-input',
    templateUrl: './import-input.html',
    styleUrls: ['./import-input.scss'],
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'asap-import-input',
    },
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ImportInputComponent implements OnInit {
  _restrictions = {
    allowedExtensions: ['.xls', '.xlsx', '.xltx', '.csv'],
  };
  uploadSaveUrl = "saveUrl";
  uploadRemoveUrl = "removeUrl";

  @Input() type: string = 'excel';
  @Output() fileSelectedChanges = new EventEmitter<File>();

  constructor(private _importComponent: ImportComponent,) { }

  ngOnInit() {
    if (this.type != 'excel') {
      this._restrictions = null;
    }
  }

  _onSelect(e: any) {
    const file = e.files;

    if (file.length) {
      if (!file[0].validationErrors) {
        this.fileSelectedChanges.emit(file[0].rawFile);
        this._importComponent.updateImportObject({});
      }
    }
  }
}
